import Vue from "vue";
import Vuetify from "vuetify";

import "../static/material-design/material-design.css";
import "vuetify/dist/vuetify.min.css";

Vue.use(Vuetify);



// WEBPACK FOOTER //
// ./src/vuetify.js